import React from 'react';
import { ErrorContainer, ErrorCopy } from './Error.styles';

export type ErrorProps = React.HTMLAttributes<HTMLElement> & {
  message?: React.ReactNode;
};

export const Error: React.FC<ErrorProps> = ({ message, ...rest }) => (
  <ErrorContainer {...rest}>
    <ErrorCopy data-testid="error-copy">{message}</ErrorCopy>
  </ErrorContainer>
);

export default Error;
